import { render, staticRenderFns } from "./CvGrade.vue?vue&type=template&id=48056201&scoped=true"
import script from "./CvGrade.vue?vue&type=script&lang=js"
export * from "./CvGrade.vue?vue&type=script&lang=js"
import style0 from "./CvGrade.vue?vue&type=style&index=0&id=48056201&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48056201",
  null
  
)

export default component.exports